module.exports = __webpack_public_path__ + "static/media/mn23.2288f0b3.jpeg";